import { useChat } from '../contexts/ChatContext'

const exampleQuestions = [
  'ما هي شروط الزواج',
  'ما هو التنظيم القضائي في الجزائر',
  'ما هي اركان الكفالة'
]

export default function EmptyState() {
  const { userProfile, sendMessage, isStreaming } = useChat()

  const handleQuestionClick = (question) => {
    if (!isStreaming) {
      sendMessage(question)
    }
  }

  // Get name from profile or use default
  const name = userProfile?.name || 'المستخدم'

  return (
    <div className="flex flex-col h-full">
      {/* Welcome Section - Upper part */}
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img
            src="/img/logo_light.svg"
            alt="AIlex"
            className="h-16 w-auto block dark:hidden"
          />
          <img
            src="/img/logo_dark.svg"
            alt="AIlex"
            className="h-16 w-auto hidden dark:block"
          />
        </div>

        {/* Welcome Message */}
        <div className="text-3xl font-bold text-foreground mb-3 animate-fade-in">
          مرحباً {name}
        </div>

        {/* Start Prompt */}
        <div className="text-base text-muted-foreground mb-4 leading-relaxed animate-fade-in max-w-md">
          مساعدك القانوني الذكي لفهم القوانين الجزائرية
        </div>
      </div>

      {/* Example Questions - Lower part near input */}
      <div className="px-4 pb-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-xs text-muted-foreground text-center mb-3 font-medium">
            أو جرّب أحد الأمثلة
          </div>

          {/* Horizontal on large screens, vertical on small */}
          <div className="flex flex-col md:flex-row gap-2 md:gap-3 justify-center">
            {exampleQuestions.map((question, index) => (
              <button
                key={index}
                onClick={() => handleQuestionClick(question)}
                disabled={isStreaming}
                className="bg-card text-foreground border border-border rounded-xl px-4 py-2.5 text-sm text-right md:text-center hover:bg-muted hover:border-primary hover:shadow-md active:scale-[0.98] transition-all duration-150 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed animate-fade-in flex-1 md:max-w-[200px]"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <span className="line-clamp-2">{question}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
